{ tenantType, userType } = require '@atlassiansox/analytics-web-client'
Auth = require 'db/auth'
Analytics = require('lib/analytics').default
Browser = require 'lib/browser'
ClientConfig = require 'debug/client-config'
EMAUEmbedWhitelist = require 'data/emau-embed-whitelist'
{ getQueryParameter } = require 'lib/util'
trackGoogleTagManager = require 'debug/trackGoogleTagManager'

window.sp? 'newTracker', 'cf', window.snowplowCloudfrontServer,
  appId: ClientConfig.get('appId') or 'web'
  cookieDomain: '.trello.com'
  respectDoNotTrack: true

if Auth.isLoggedIn()
  window.sp?('setUserId:cf', Auth.myId())
  trackGoogleTagManager.push isLoggedIn: true
else
  trackGoogleTagManager.push isLoggedIn: false

emauEmbeddable = getQueryParameter('iframeSource', '') in EMAUEmbedWhitelist

if Auth.isLoggedIn() && (!Browser.isEmbeddedDocument() || emauEmbeddable)
  Analytics.setTenantInfo tenantType.NONE
  Analytics.setUserInfo userType.TRELLO, Auth.myId()
  Analytics.startUIViewedEvent()

window.dataLayer?.push inApp: true
window.sp? ->
  trackGoogleTagManager.push
    event: 'snowplow.loaded'
    snowplow:
      domain_userid: this.cf?.getDomainUserId()



// WEBPACK FOOTER //
// ./app/scripts/init/init-analytics.coffee